export default function SendIcon() {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.235 2.686C18.667 1.491 17.509 0.332999 16.314 0.765999L1.70904 6.048C0.510042 6.482 0.365042 8.118 1.46804 8.757L6.13004 11.456L10.293 7.293C10.4816 7.11084 10.7342 7.01005 10.9964 7.01232C11.2586 7.0146 11.5095 7.11977 11.6949 7.30518C11.8803 7.49059 11.9854 7.7414 11.9877 8.0036C11.99 8.26579 11.8892 8.5184 11.707 8.707L7.54404 12.87L10.244 17.532C10.882 18.635 12.518 18.489 12.952 17.291L18.235 2.686Z"
        fill="#0073FF"
      />
    </svg>
  );
}
